
















































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default defineComponent({
  name: 'UMichSandboxQ1',
  components: {STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      attachments: [] as File[],
      inputs: {
        input1: null,
        input2: null,
        input3: null,
        input4: null,
        input5: null,
      },
      prompts: [
        'a) The product forms with an experimentally determinable regioselectivity:',
        'b) The product forms with an experimentally determinable diastereoselectivity:',
        'c) The product forms with an experimentally determinable enantioselectivity:',
        'd) The product forms with an experimentally determinable stereospecificity derived from the diene:',
        'e) The product forms with an experimentally determinable stereospecificity derived from the dienophile:',
      ],
      rules: [
        (value: File[]) => {
          // If no file is selected
          if (!value || !value.length) {
            return true;
          }

          // Check file count
          if (value.length > 1) {
            return `You can upload a maximum of 1 image(s).`;
          }

          // Check file sizes
          for (let file of value) {
            if (file.size > 20000000) {
              return `File size must be less than 20 MB.`;
            }
          }

          return true;
        },
      ],
    };
  },
  computed: {
    imageName(): string {
      return prefixPublicAsset('/img/assignments/UMichQ1.png');
    },
    attachments(): File[] {
      return [...this.attachments];
    },
  },
  methods: {},
});
